const LOGINMODAL = "LOGINMODAL";
const RESETPASSWORDMODAL = "RESETPASSWORDMODAL";
const JOINMODAL = "JOINMODAL";
const RESENDVERIFICATIONMODAL = "RESENDVERIFICATIONMODAL";

export { LOGINMODAL, RESETPASSWORDMODAL, RESENDVERIFICATIONMODAL, JOINMODAL };
